import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: {
      xs: '16px 12px',
      md: ' 24px',
    },
    borderRadius: '16px',
    maxWidth: { md: '352px' },
    backgroundColor: 'background.paper',
    gap: '8px',
  },
  infoWrapper: {
    display: 'flex',
    gap: '16px',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    height: '48px',
    width: '48px',
    display: 'flex',
    marginTop: '3px',
    borderRadius: '50%',
  },
  location: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
